module.exports = __webpack_public_path__ + "images/choice_shield_7410d15.png";